module.exports = __webpack_public_path__ + "img/Saint Barthelemy.fe3ac598.svg";